export function getVeevaDomainName(env){
    return env === "dev"
    ? "@lillysbx.com"
    : env === "qa"
    ? "@lillyqa.com"
    : env === "prod"
    ? "@lilly.com"
    : "";
}